import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WithSubscriptionComponent } from '@sabstravtech/obtservices/angular';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';

@Component({
  selector: 'app-update-selection',
  templateUrl: './update-selection-dialog.component.html',
  styleUrls: ['./update-selection-dialog.component.scss'],
  standalone: false
})
export class UpdateSelectionDialogComponent extends WithSubscriptionComponent {
  constructor(public activeModal: NgbActiveModal) {
    super();
  }
}

LightningModalTypes.UpdateSelectionDialogComponent.component = UpdateSelectionDialogComponent;
